export const SET_EDITOR_UTILITIES = 'SET_EDITOR_UTILITIES';
export const SET_EDITOR_FOCUSED = 'SET_EDITOR_FOCUSED';
export const SET_CONTENT_LOADED = 'SET_CONTENT_LOADED';